module.exports = __webpack_public_path__ + "img/homebut.14c714f8.png";